/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetResourceGroupQuery } from "~/generated/graphql";

type Props = {
  resourceGroupId: string;
};

export function useGetResourceGroup({ resourceGroupId }: Props) {
  const { data, loading, error } = useGetResourceGroupQuery({
    variables: { resourceGroupId },
  });

  return { resourceGroup: data?.group ?? undefined, loading, error } as const;
}
